module.exports = __webpack_public_path__ + "img/1-2.8ae742b5.png";